import React, { useEffect, useState } from 'react';
import "./News.css"
import axios from 'axios';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { logEvent } from '../utils/logger';


function News({ checkLogin, user }) {
  const [isLoading, setIsLoading] = useState(true);
  const [news, setNews] = useState([]);
  const [userIsAdmin, setUserIsAdmin] = useState(false);

  const jwt_token = localStorage.getItem('jwt_authorization');
  let { slug } = useParams();

  useEffect(() => {

    const event = {
      event: {
        label: 'PageView',
        data: {
          page: 'Updates'
        }
      }

    }

    logEvent(event);

    let payload = {};

    if (slug && isLoading === true) {
      payload = {
        jwt_token,
        op: 'get',
        slug: slug}
        axios.post(`${process.env.REACT_APP_BACKEND_HOST}/blog-post`, payload)
        .then(response => {
          setNews(response.data);
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error fetching posts', error);
        });
  
        if (user) {
          setUserIsAdmin(user.is_admin);
        }
  
    } else {
      payload = {
        jwt_token,
        op: 'get'
      }
         axios.post(`${process.env.REACT_APP_BACKEND_HOST}/blog-post`, payload)
      .then(response => {
        setNews(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error('Error fetching posts', error);
      });

      if (user) {
        setUserIsAdmin(user.is_admin);
      }

    }


  }, [setNews]);

  const deletePost = (slug) => {
    let payload = {
      jwt_token,
      op: 'delete',
      slug: slug
    }

    axios.post(`${process.env.REACT_APP_BACKEND_HOST}/blog-post`, payload)
      .then(response => {

        let newPosts = news.filter(post => post.slug !== slug);
        setNews(newPosts);

      })
      .catch(error => {
        console.error('Error fetching posts', error);
      });
  }


  if (!isLoading) { // Render only when not loading and user data is available
    return (
      <div>
        
        <div className="page-content mobile-admin" style={{ flexDirection: 'column' }}>
          <span className='span-text'>Updates</span>

          <div className='news-post-list'>
            {news.length === 0 ? (
              <div className='no-posts'>No posts</div>
            ) : (
              news.map((post, index) => {
                const adjustedDate = moment(post.date_created).subtract(8, 'hours').format('M/D/YYYY | h:m A');
                return (
                  <div className='news-post-container' key={index}>
                    <a href={`/updates/${post.slug}`} className='news-post-title'>{post.title}</a>
                    <div className='news-post-content' dangerouslySetInnerHTML={{ __html: post.content }}></div>
                    <div className='news-post-date'>{adjustedDate}</div>
                    {userIsAdmin ? (
                      <div onClick={() => deletePost(post.slug)} className='news-post-delete'>Delete</div>
                    ) : null}
                  </div>
                );
              })
            )}
          </div>

        </div>


      </div>
    );
  } else {

    return (

      <div className="page-content" style={{ flexDirection: 'column' }}>

      </div>

    );
  }


}

export default News;
